import SolidGeometry, { prismGeometry } from "./solid-geometry";

// Prisma de base losango (vértices nos pontos médios da caixa)
export default class LozangleGeometry extends SolidGeometry {
  constructor(color, { width, height, depth }, positions) {
    const w = width / 2;
    const h = height / 2;
    const geometry = prismGeometry([[0, -h], [w, 0], [0, h], [-w, 0]], depth);
    super("lozangle", color, geometry, positions);
  }
}
